import { createSlice, current } from '@reduxjs/toolkit';
import Strings from '@/constants/String';
import BaseApiState, { createBaseAPi } from "@/api/BaseApiState"
import { getProfile,getProfileV2, updateUserProfile,getMyBookingById, getMyBookings, getmyBookingsWithPagination,wishlist, writeReview, getAllReview,getUserPendingBookings} from "../thunkMidddleware/userMiddleware";
// Same output as moment().format("DD-MM-YYYY") (local time), without putting
// moment in the startup bundle: the store loads on every page.
const todayDDMMYYYY = () => {
    const d = new Date();
    const pad = (n: number) => String(n).padStart(2, "0");
    return `${pad(d.getDate())}-${pad(d.getMonth() + 1)}-${d.getFullYear()}`;
};
import { Coupon } from '@/types/interfaceType';


interface InitialStateType{
    wishlistResponse: createBaseAPi,
    userProfile: createBaseAPi,
    userProfileUpdate: createBaseAPi,
    userSelectedSlots: any[],
    userSelectedSport:any,
    userSelectedDate:any,
    userSelectedCourt:any,
    myBookings:createBaseAPi,
    myBookingsWithPagination:createBaseAPi,
    getMyBookingByIdResponse:createBaseAPi,

    getUserPendingBookingsDetaild: createBaseAPi,
    writeReviewDetails:createBaseAPi,
    getAllReviewDetails:createBaseAPi,
    showBDLUserAccountPopUp:boolean,
    showDBLMyBookingPage:boolean,
    appliedCoupon:Coupon,
 
}


const initialState :InitialStateType= {
    getMyBookingByIdResponse:BaseApiState,
    wishlistResponse:BaseApiState,
    userProfile: BaseApiState,
    userProfileUpdate: BaseApiState,
    userSelectedSlots: [],
    userSelectedSport: null,
    userSelectedDate: todayDDMMYYYY(),
    userSelectedCourt: null,
    myBookings: BaseApiState,
    myBookingsWithPagination:BaseApiState,
    getUserPendingBookingsDetaild: BaseApiState,
    writeReviewDetails: BaseApiState,
    getAllReviewDetails: BaseApiState,
    showBDLUserAccountPopUp:false,
    showDBLMyBookingPage:false,
    appliedCoupon:null,

};


const userSlice = createSlice({
    name: "user",
    initialState,
    reducers: {
        resetAllReviewDetails:(state)=>{
            state.getAllReviewDetails = BaseApiState
        },
        setAppliedCoupon:(state, action)=>{
            state.appliedCoupon = action.payload || null;
        },
        removeAppliedCoupon:(state)=>{
            state.appliedCoupon= null;
        },
        setShowBDLUserAccountPopUp:(state, action) => {
            state.showBDLUserAccountPopUp = action.payload || false
          },
          setShowDBLMyBookingPage:(state, action) => {
            state.showDBLMyBookingPage = action.payload || false
          },
        filterUsers: (state, action) => {

        },
        resetMyBookings:(state)=>{
            state.myBookings = BaseApiState;
        },
        ResetUserProfileUpdate: (state) => {
            state.userProfileUpdate = BaseApiState
        },
        setuserSelectedSport: (state, action) => {
            state.userSelectedSport = action.payload
        },
        setUserSelectedSlots: (state, action) => {
            state.userSelectedSlots = action.payload
        },
        setUserSelectedDate: (state, action) => {
            state.userSelectedDate = action.payload
        },
        setUserSelectedCourt: (state, action) => {
            state.userSelectedCourt = action.payload
        },

        ResetUserSelectedDataUpdate: (state) => {
            state.userSelectedSlots = [],
                state.userSelectedSport = null,
                state.userSelectedDate = todayDDMMYYYY(),
                state.userSelectedCourt = null
        }


    },
    extraReducers: (builder) => {
        builder
        .addCase(wishlist.pending, (state) => {
            state.wishlistResponse.isLoading = true;
            state.wishlistResponse.error = null;
        })
        .addCase(wishlist.fulfilled, (state, action) => {
            state.wishlistResponse.isLoading = false;
            state.wishlistResponse.success = action.payload?.success;
            state.wishlistResponse.payload = action.payload?.payload;
        })
        .addCase(wishlist.rejected, (state, action) => {
            state.wishlistResponse.isLoading = false;
            state.wishlistResponse.error = action.error as string;
            state.wishlistResponse.payload = null
            state.wishlistResponse.success = false

        });
        //----------------------------------------------
        builder
            .addCase(getProfile.pending, (state) => {
                state.userProfile.isLoading = true;
                state.userProfile.error = null;
            })
            .addCase(getProfile.fulfilled, (state, action) => {
                state.userProfile.isLoading = false;
                state.userProfile.success = action.payload?.success;
                state.userProfile.payload = action.payload?.payload;
            })
            .addCase(getProfile.rejected, (state, action) => {
                state.userProfile.isLoading = false;
                state.userProfile.error = action.error as string;
                state.userProfile.payload = null
                state.userProfile.success = false

            });

               //----------------------------------------------
        builder
        .addCase(getProfileV2.pending, (state) => {
            state.userProfile.isLoading = true;
            state.userProfile.error = null;
        })
        .addCase(getProfileV2.fulfilled, (state, action) => {
            state.userProfile.isLoading = false;
            state.userProfile.success = action.payload?.success;
            state.userProfile.payload = action.payload?.payload;
        })
        .addCase(getProfileV2.rejected, (state, action) => {
            state.userProfile.isLoading = false;
            state.userProfile.error = action.error as string;
            state.userProfile.payload = null
            state.userProfile.success = false

        });
        //---------------------------------------------
        builder
            .addCase(updateUserProfile.pending, (state) => {
                state.userProfileUpdate.isLoading = true;
                state.userProfileUpdate.error = null;

                // state.userProfile.isLoading = true;
                state.userProfile.error = null;

            })
            .addCase(updateUserProfile.fulfilled, (state, action) => {
                state.userProfileUpdate.isLoading = false;
                state.userProfileUpdate.success = action.payload?.success;
                state.userProfileUpdate.payload = action.payload?.payload;
                state.userProfile.isLoading = false;
                if(action.payload?.success){
                    state.userProfile.success = action.payload?.success;
                    state.userProfile.payload = action.payload?.payload;
                }
              

            })
            .addCase(updateUserProfile.rejected, (state, action:any) => {
                state.userProfileUpdate.isLoading = false;
                state.userProfileUpdate.error = action?.payload || action?.error || action?.errorMessage;
                state.userProfileUpdate.errorInput = action?.payload?.errorInput || null;

                state.userProfileUpdate.payload = null
                state.userProfileUpdate.success = false


                // state.userProfile.isLoading = false;
                // state.userProfile.error = action?.payload || action?.error;
                // state.userProfile.payload = null
                // state.userProfile.success = false

            });

        // builder
        //     .addCase(getMyBookings.pending, (state) => {
        //         state.myBookings.isLoading = true;
        //         state.myBookings.error = null;
        //     })
        //     .addCase(getMyBookings.fulfilled, (state, action) => {
        //         state.myBookings.isLoading = false;
        //         state.myBookings.success = action.payload?.success;
        //         state.myBookings.payload =action.payload?.payload
        //         state.myBookings.dataToRender =action.payload?.currentPage === 1?[...action.payload?.payload]: [...state.myBookings.dataToRender,...action.payload?.payload];
        //         state.myBookings.currentPage= action.payload?.currentPage
        //         state.myBookings.error = null
        //     })
        //     .addCase(getMyBookings.rejected, (state, action) => {
        //         state.myBookings.isLoading = false;
        //         state.myBookings.error = action?.payload || action?.error;
        //         state.myBookings.success = false
        //         state.myBookings.payload = null
        //     });
                builder
                .addCase(getMyBookings.pending, (state) => {
                    state.myBookings.isLoading = true;
                    state.myBookings.error = null;
                })
                .addCase(getMyBookings.fulfilled, (state, action) => {
                    state.myBookings.isLoading = false;
                    state.myBookings.success = action.payload?.success;
                    state.myBookings.payload =action.payload?.payload
                    state.myBookings.error = null
                })
                .addCase(getMyBookings.rejected, (state, action) => {
                    state.myBookings.isLoading = false;
                    state.myBookings.error = action?.payload || action?.error as any;
                    state.myBookings.success = false
                    state.myBookings.payload = null
                });

                //-----------------------------------------------------------------------------------
            builder
            .addCase(getmyBookingsWithPagination.pending, (state,action:any) => {
                const page = action.meta.arg?.page || 1;
                if (page === 1) {
                    state.myBookingsWithPagination.isLoading = true; // full loader only on first page
                }

                state.myBookingsWithPagination.error = null;
            })
               .addCase(getmyBookingsWithPagination.fulfilled, (state, action: any) => {
                state.myBookingsWithPagination.isLoading = false;
                state.myBookingsWithPagination.success = action.payload?.success;
                state.myBookingsWithPagination.error = null;
            
                const newPayload = action.payload?.payload;
                const page = action.meta.arg?.page || 1;
                if (page === 1 || !state.myBookingsWithPagination.payload) {
                    // ✅ First page OR reset → replace
                    state.myBookingsWithPagination.payload = newPayload;
                } else {
                    // ✅ Next pages → append
                    state.myBookingsWithPagination.payload = {
                        ...newPayload,
                        bookings: [
                            ...(state.myBookingsWithPagination.payload?.bookings || []),
                            ...(newPayload?.bookings || [])
                        ]
                    };
                }
            })
            .addCase(getmyBookingsWithPagination.rejected, (state, action) => {
                state.myBookingsWithPagination.isLoading = false;
                state.myBookingsWithPagination.error = action?.payload || action?.error as any;
                state.myBookingsWithPagination.success = false
                state.myBookingsWithPagination.payload = null
            });
        builder
            .addCase(getUserPendingBookings.pending, (state) => {
                state.getUserPendingBookingsDetaild.isLoading = true;
                state.getUserPendingBookingsDetaild.error = null;
            })
            .addCase(getUserPendingBookings.fulfilled, (state, action) => {
                state.getUserPendingBookingsDetaild.isLoading = false;
                state.getUserPendingBookingsDetaild.success = action.payload?.success;
                state.getUserPendingBookingsDetaild.payload = action.payload?.payload;
                state.getUserPendingBookingsDetaild.error = null
            })
            .addCase(getUserPendingBookings.rejected, (state, action) => {
                state.getUserPendingBookingsDetaild.isLoading = false;
                state.getUserPendingBookingsDetaild.error = action?.payload || action?.error;
                state.getUserPendingBookingsDetaild.success = false
                state.getUserPendingBookingsDetaild.payload = null
            });
        // ------------------------------------------------------------

        builder
            .addCase(writeReview.pending, (state) => {
                state.writeReviewDetails.isLoading = true;
                state.writeReviewDetails.error = null;
            })
            .addCase(writeReview.fulfilled, (state, action) => {
                state.writeReviewDetails.isLoading = false;
                state.writeReviewDetails.success = action.payload?.success;
                state.writeReviewDetails.payload = action.payload?.payload;
                state.writeReviewDetails.error = null
            })
            .addCase(writeReview.rejected, (state, action) => {
                state.writeReviewDetails.isLoading = false;
                state.writeReviewDetails.error = action?.payload || action?.error;
                state.writeReviewDetails.success = false
                state.writeReviewDetails.payload = null
            });

        // ------------------------------------------------------------

            builder
            .addCase(getMyBookingById.pending, (state) => {
                state.getMyBookingByIdResponse.isLoading = true;
                state.getMyBookingByIdResponse.error = null;
            })
            .addCase(getMyBookingById.fulfilled, (state, action) => {
                state.getMyBookingByIdResponse.isLoading = false;
                state.getMyBookingByIdResponse.success = action.payload?.success;
                state.getMyBookingByIdResponse.payload =action.payload?.payload
                state.myBookings.error = null
            })
            .addCase(getMyBookingById.rejected, (state, action) => {
                state.getMyBookingByIdResponse.isLoading = false;
                state.getMyBookingByIdResponse.error = action?.payload || action?.error as any;
                state.getMyBookingByIdResponse.success = false
                state.getMyBookingByIdResponse.payload = null
            });

        // ------------------------------------------------------------

            builder
            .addCase(getAllReview.pending, (state,action:any) => {
                const page = action.meta.arg?.page || 1;
                if (page === 1) {
                    state.getAllReviewDetails.isLoading = true; // full loader only on first page
                }
                state.getAllReviewDetails.error = null;
            })
          

            .addCase(getAllReview.fulfilled, (state, action: any) => {
                state.getAllReviewDetails.isLoading = false;
                state.getAllReviewDetails.success = action.payload?.success;
                state.getAllReviewDetails.error = null;
            
                const newPayload = action.payload?.payload;
                const page = action.meta.arg?.page || 1;
                if (page === 1 || !state.getAllReviewDetails.payload) {
                    // ✅ First page OR reset → replace
                    state.getAllReviewDetails.payload = newPayload;
                } else {
                    // ✅ Next pages → append
                    state.getAllReviewDetails.payload = {
                        ...newPayload,
                        reviews: [
                            ...(state.getAllReviewDetails.payload?.reviews || []),
                            ...(newPayload?.reviews || [])
                        ]
                    };
                }
            })

            .addCase(getAllReview.rejected, (state, action) => {
                state.getAllReviewDetails.isLoading = false;
                state.getAllReviewDetails.error = action?.payload || action?.error as any;
                state.getAllReviewDetails.success = false
                state.getAllReviewDetails.payload = null
            });

          

    }
});


export const { setAppliedCoupon,resetAllReviewDetails,removeAppliedCoupon,setShowBDLUserAccountPopUp,setShowDBLMyBookingPage,filterUsers,resetMyBookings, ResetUserProfileUpdate, setUserSelectedSlots, ResetUserSelectedDataUpdate, setuserSelectedSport, setUserSelectedDate, setUserSelectedCourt } = userSlice.actions;

export default userSlice.reducer;